import {
  StopStatus,
  StopType,
  VendingVehicleScheduleState,
} from '../redux/type';
import { pageInfo } from './constant';
import { stringToEnum } from './util';
export * from './parseGeoJson';

export interface UpgradeDetail {
  appName?: string;
  appAlias?: string;
  issueTaskNumber?: string;
  version?: string;
  upgradeType?: number;
  upgradeTypeName?: string;
  progressType?: number;
  progressTypeName?: string;
  downloadStep?: string;
  upgradeStep?: string;
  estimatedCompletionTime?: string;
  failedReason?: string;
  downloadMethod?: string; // FULL_SPEED or LIMIT_SPEED
}
export enum MapType {
  CityLevelMap = 0,
  StationLevelMap = 1,
  ControlLevelMap = 2,
  SingleVehicleMap = 3,
}
interface Marker {
  name: string;
  lat: number;
  lon: number;
  id: number;
  tipsInfo?: string;
  hasAlarmEvent?: boolean | undefined;
  vehicleBusinessType?: string;
}
interface Stop {
  name: string;
  lat: number;
  lon: number;
  id: number;
  stopType: StopType;
  status: StopStatus;
  tipsInfo: string;
}
interface MapData {
  station: {
    [id: number]: Marker;
  };
  status: {
    [id: number]: {
      [vId: number]: Marker;
    };
  };
  stop: {
    [id: number]: {
      [sId: number]: Stop;
    };
  };
  finishedRoutingPoint: {
    [id: number]: { lat: number; lon: number }[];
  };
  totalRoutingPoint: {
    [id: number]: { lat: number; lon: number }[];
  };
  type: MapType;
  zoom: number;
  vehicleBusinessType: string;
}

export const isMobile = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
);

export const addClass = () => {
  // 判断是否移动端
  const isPhone = isMobile;
  if (isPhone) {
    document.body.className = 'm-app';
  }
};

export const isNullObject = (obj: any) => {
  if (!obj) {
    return true;
  }
  return Object.keys(obj).length === 0;
};

export const isEmpty = (param: any) => {
  if (Array.isArray(param) || typeof param === 'string') {
    return param.length === 0;
  }
  return true;
};

export const formatTime = (ms: number) => {
  const minutes = Math.floor(ms / 60000);
  const seconds = Math.floor((ms % 60000) / 1000);
  return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
};

export const translator = (
  latLng: any,
  cb: AnyFunc,
  useTranslator: boolean = false
) => {
  const winAny = window as any;
  const { BMapGL } = winAny;
  if (useTranslator && BMapGL && BMapGL.Convertor) {
    const convertor = new BMapGL.Convertor();
    convertor.translate([new BMapGL.Point(latLng.lng, latLng.lat)], 1, 5, (
      data: any,
    ) => {
      if (data.status === 0 && data.points && data.points.length > 0) {
        cb(data.points);
      } else {
        cb([latLng]);
      }
    });
  } else {
    cb([latLng]);
  }
};
export const getPermissionById = (id: string) => {
  const store = (window as any).store;
  if (!store) {
    return false;
  }
  const state = store.getState();
  const { resourceList } = state.login;
  if (resourceList) {
    const findIndex = resourceList.findIndex((item: any) => item.code === id);
    return findIndex > -1;
  }
  return false;
};

export const getPermissionTabs = (allPermissions: any[]) => {
  const pageInPermission: any = [];
  if (allPermissions) {
    for (const pageKey in pageInfo) {
      if (pageInfo[pageKey]) {
        // 警情查看页面需要验证三个tab签存在至少一个有权限
        let findIndex = -1;
        if (pageKey === 'spv_alarm_info') {
          const tabKeys = [
            'spv_alarm_history',
            'spv_error_history',
            'spv_jira_history',
          ];
          findIndex = allPermissions.findIndex((item: any) =>
            tabKeys.includes(item.code)
          );
        } else {
          findIndex = allPermissions.findIndex(
            (item: any) => item.code === pageKey
          );
        }

        if (findIndex > -1) {
          pageInPermission.push(pageInfo[pageKey]);
        }
      }
    }
  }

  return pageInPermission;
};

export const getNewPermissionTabs = () => {
  const store = (window as any).store;
  if (!store) {
    return false;
  }
  const state = store.getState();
  const pageInPermission: any = [];

  const { resourceList } = state.login;
  if (resourceList && resourceList.length > 0) {
    for (const pageKey in pageInfo) {
      if (pageInfo[pageKey]) {
        let findIndex = -1;
        if (pageKey === 'spv_alarm_info') {
          // 警情查看页面需要验证三个tab签存在至少一个有权限
          const tabKeys = [
            'spv_alarm_history',
            'spv_error_history',
            'spv_jira_history',
          ];
          findIndex = resourceList.findIndex((item: any) =>
            tabKeys.includes(item.code)
          );
        } else {
          findIndex = resourceList.findIndex(
            (item: any) => item.code === pageKey
          );
        }
        if (findIndex > -1) {
          pageInPermission.push(pageInfo[pageKey]);
        }
      }
    }
  }

  return pageInPermission;
};

/**
 *
 * @param {string} enumGroupKey 枚举分组key
 * @param {string} fieldKey 字段key
 * @return {Object}
 */
type EnumLookup = Map<string, Map<unknown, any>>;

let cachedEnumListMap: any;
let cachedEnumLookup: EnumLookup = new Map();
let cachedStorageValue: string | null = null;
let cachedStorageLookup: EnumLookup = new Map();

const buildEnumLookup = (enumListMap: any): EnumLookup => {
  const lookup: EnumLookup = new Map();

  Object.entries(enumListMap || {}).forEach(([groupKey, items]) => {
    if (!Array.isArray(items)) {
      return;
    }

    const groupLookup = new Map<unknown, any>();
    items.forEach((item: any) => {
      if (item && !groupLookup.has(item.code)) {
        groupLookup.set(item.code, item);
      }
    });
    lookup.set(groupKey, groupLookup);
  });

  return lookup;
};

const getEnumLookup = (enumListMap: any) => {
  if (enumListMap !== cachedEnumListMap) {
    cachedEnumListMap = enumListMap;
    cachedEnumLookup = buildEnumLookup(enumListMap);
  }

  return cachedEnumLookup;
};

const getStorageEnumLookup = () => {
  const storageValue = window.localStorage.getItem('ENUM_LIST_MAP');
  if (storageValue !== cachedStorageValue) {
    cachedStorageValue = storageValue;
    try {
      cachedStorageLookup = buildEnumLookup(
        storageValue ? JSON.parse(storageValue) : {}
      );
    } catch {
      cachedStorageLookup = new Map();
    }
  }

  return cachedStorageLookup;
};

export const enumTranslator = (enumGroupKey: string, fieldKey: string) => {
  const win = window as any;
  const { common } = win.store.getState();
  const mapEnum = getEnumLookup(common.enumListMap)
    .get(enumGroupKey)
    ?.get(fieldKey);

  if (mapEnum) {
    return mapEnum.name;
  }

  return (
    getStorageEnumLookup().get(enumGroupKey)?.get(fieldKey)?.name || fieldKey
  );
};

/**
 * 通过单个code或者code的数组从枚举中获取name
 * 支持两种 list 结构：默认 { code, name }；当 options.labelAndValue 为 true 时，list 使用 { value, label }
 * @param {({ code: string | number; name: string }[] | { value: string | number; label: string }[] | null | undefined)} list
 * @param {(string | number | Array<string | number> | null | undefined)} key
 * @param {{ labelAndValue?: boolean }} [options] 如果为 true, list 中使用 value/label
 * @return {string}
 */
export const translateCodesToNames = (
  list:
    | { code: string | number; name: string }[]
    | { value: string | number; label: string }[]
    | null
    | undefined,
  key: string | number | Array<string | number> | null | undefined,
  options?: { labelAndValue?: boolean }
): string => {
  if (key === null || key === undefined) {
    return '';
  }

  if (!list || list.length === 0) {
    if (Array.isArray(key)) {
      return key.map((k) => String(k)).join('; ');
    }
    return String(key);
  }

  const labelAndValue = !!(options && options.labelAndValue);

  const findName = (k: string | number) => {
    const found = (list as any[]).find((item) => {
      const itemCode = labelAndValue ? item.value : item.code;
      return String(itemCode) === String(k);
    });
    if (!found) {
      return String(k);
    }
    return labelAndValue ? found.label : found.name;
  };

  if (Array.isArray(key)) {
    return key.map((k) => findName(k)).join('；');
  }

  return findName(key);
};

export const translatorVendingScheduleState = (key: string) => {
  return stringToEnum(VendingVehicleScheduleState, key) || '';
};

export const formatMapData = (params: {
  nation: boolean;
  zoom: number;
  showFinishedRouting: boolean;
  city?: City;
  station?: Station;
  vehicle?: Vehicle;
}) => {
  const win = window as any;
  const store = win.store.getState();
  const { common } = store;
  const { alarmEventList } = common;
  const { nation, zoom, showFinishedRouting, city, station, vehicle } = params;
  const data: any = {
    city: {},
    station: {},
    vehicle: {},
    stop: {},
    finishedRoutingPoint: {},
    totalRoutingPoint: {},
    currentRoutingPoint: {},
    zoom,
  };
  if (nation) {
    data.city = common.city;
    return data;
  }

  if (station) {
    for (const stationItem of Object.values(station)) {
      const { name, lat, lon, id } = stationItem;
      data.station[id] = {
        name,
        lat,
        lon,
        id,
      };
    }
  }

  if (vehicle) {
    for (const vehicleItem of Object.values(vehicle)) {
      const {
        lat,
        lon,
        name,
        stop,
        finishedRoutingPoint,
        currentRoutingPoint,
        businessType,
      } = vehicleItem;

      data.vehicle[name] = {
        name,
        lat,
        lon,
        vehicleBusinessType: businessType,
        hasAlarmEvent: alarmEventList[name],
      };

      if (stop && !isEmpty(stop)) {
        data.stop[name] = {};
        stop.forEach((stopItem: StopItem, index: number) => {
          if (stopItem.lat && stopItem.lon) {
            data.stop[name][index] = stopItem;
          }
        });
      }
      if (showFinishedRouting) {
        data.finishedRoutingPoint[name] = finishedRoutingPoint || [];
      }
      data.totalRoutingPoint[name] = currentRoutingPoint || [];
      data.currentRoutingPoint[name] = currentRoutingPoint || [];
    }
  }
  return data;
};

export const transformLocationWgs84togcj02 = (location: {
  lon: any;
  lat: any;
}): { lon: number; lat: number } => {
  const win = window as any;
  const formatedLoaction = win
    .coordtransform()
    .wgs84togcj02(parseFloat(location.lon), parseFloat(location.lat));
  return { lon: formatedLoaction[0], lat: formatedLoaction[1] };
};

/**
 * 形如12:02的时间字符串
 * @param {string} time 时间字符串
 * @return {number}
 */
export const formatDayTime = (time: string) => {
  if (typeof time != 'string') {
    return -1;
  }
  const [hours, minutes] = time?.split(':') || [];
  return parseInt(minutes) * 60 + parseInt(hours) * 3600;
};

/**
 * 校验两个picker时间区间是否有重叠
 * @param {Object} source 对比项
 * @param {Object} current 被对比项
 * @return {boolean}
 */
export const validatePickerItem = (source: any, current: any) => {
  if (!source.value || !current.value) {
    return false;
  }
  const [startTimeStr, endTimeStr] = source.value.split('-');
  const formatStart = formatDayTime(startTimeStr);
  const formatEnd = formatDayTime(endTimeStr);
  const [start, end] = current.value.split('-');
  const formatStartNum = formatDayTime(start);
  const formartEndNum = formatDayTime(end);
  const hasCross =
    (formatStart >= formatStartNum && formatStart <= formartEndNum) ||
    (formatEnd >= formatStartNum && formatEnd <= formartEndNum) ||
    (formatStart <= formatStartNum && formatEnd >= formartEndNum);
  return hasCross;
};

export function isString(opt: any): boolean {
  return typeof opt === 'string';
}

export function isFunction(opt: any): boolean {
  return typeof opt === 'function';
}

export function getRandom(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min)) + min;
}
/**
 * 防抖函数
 * @param fn 要防抖的函数
 * @param wait 延迟时间（毫秒），默认50ms
 * @param immediate 是否立即执行，默认false（延时执行）
 * @returns 防抖后的函数
 */
export function debounce<T extends (...args: any[]) => any>(
  fn: T,
  wait: number = 50,
  immediate: boolean = false
): (...args: Parameters<T>) => void {
  let timer: NodeJS.Timeout | null = null;
  let hasExecuted = false; // 用于immediate模式下跟踪是否已执行

  return function (this: any, ...args: Parameters<T>) {
    const callNow = immediate && !timer;

    // 清除之前的定时器
    if (timer) {
      clearTimeout(timer);
    }

    if (callNow) {
      // 立即执行模式：第一次调用立即执行
      fn.apply(this, args);
      hasExecuted = true;
    }

    // 设置新的定时器
    timer = setTimeout(() => {
      timer = null;
      hasExecuted = false;

      if (!immediate) {
        // 延时执行模式：在延时后执行
        fn.apply(this, args);
      }
    }, wait);
  };
}

export const formatSelectOptions = (
  list: { code: string | number; name: string }[] | null
) => {
  if (!list) {
    return [];
  }
  return list.map((item) => {
    return {
      label: item.name,
      value: item.code,
    };
  });
};

export const setDb = (num: number) => {
  if (num < 10) {
    return '0' + num;
  } else {
    return '' + num;
  }
};

export function formatTimetoString(time: number) {
  const hour = setDb(Math.floor((time % 86400000) / 3600000));
  const minutes = setDb(Math.floor((time % 3600000) / 60000));
  const seconds = setDb(Math.floor((time % 60000) / 1000));
  const timeLong1 = hour + ':' + minutes + ':' + seconds;
  return timeLong1;
}

export const createRequestId = () => {
  return Math.ceil(Math.random() * 1000000);
};
export const isNumber = (value: any) => {
  return typeof value === 'number' && !isNaN(value);
};

/**
 * 将原始米值转为展示用的公里字符串。
 * - 有效值（含 0）：转为 km 并保留两位小数
 * - 异常值（null / undefined / NaN）：兜底为 '0'
 */
export const formatMileageFromMeter = (
  meter: number | null | undefined
): string => {
  if (meter == null || Number.isNaN(meter)) return '0';
  return (meter / 1000).toFixed(2);
};

export const videoExtensions = [
  '.mp4',
  '.avi',
  '.mov',
  '.wmv',
  '.flv',
  '.webm',
  '.mkv',
  '.m4v',
  '.ogm',
  '.mpg',
  '.ogv',
  '.asx',
  '.mpeg',
];

export const imageExtensions = [
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
  '.bmp',
  '.webp',
  '.svg',
  '.tif',
  '.tiff',
  '.xbm',
  '.jfif',
  '.pjp',
  '.apng',
  '.heif',
  '.ico',
  '.svgz',
  '.heic',
  '.pjpeg',
  '.avif',
];
